import React from 'react';
import { Box } from '@mui/material';
import { numberToCurrencyString, pluralize } from 'further-ui/utils';

type PortfolioSizeTooltipProps = {
  portfolioSizeDifference: number;
  minimumInvestorPortfolioSize: number;
  shouldShowInfoForPortfolioSizeOne: boolean;
  lowestInvestmentCapitalOfLowestDiversifiedInvestors: number;
};

const PortfolioSizeTooltip: React.FC<PortfolioSizeTooltipProps> = ({
  portfolioSizeDifference,
  minimumInvestorPortfolioSize,
  shouldShowInfoForPortfolioSizeOne,
  lowestInvestmentCapitalOfLowestDiversifiedInvestors,
}) => {
  return (
    <Box padding={1}>
      <p>
        If all shares are able to be allocated, this allocation will result in
        less than 2% of capital remaining in the tranche. If this is the final
        deal, and there are no live convertibles in the tranche, please tick the
        final deal box to move residual funds to the investor cash balance after
        allocation.
      </p>
      {portfolioSizeDifference > 1 && (
        <>
          <br />
          <p>
            Please note that if this allocation is completed, some investors
            will finish deployment less diversified than expected, as they are
            more than 1 company away from the minimum investor portfolio size (
            {minimumInvestorPortfolioSize}{' '}
            {pluralize('company', minimumInvestorPortfolioSize, 'companies')}).
          </p>
        </>
      )}
      {shouldShowInfoForPortfolioSizeOne && (
        <>
          <br />
          <p>
            Please note that if this allocation is completed, some investors
            will finish deployment less diversified than expected, as the deal
            share price is too high to deploy them. If you wish to include all
            investors in this deal, please use a share price of{' '}
            {numberToCurrencyString(
              lowestInvestmentCapitalOfLowestDiversifiedInvestors,
            )}{' '}
            or below (a share split is recommended to solve this).
          </p>
        </>
      )}
    </Box>
  );
};

export default PortfolioSizeTooltip;
